export default {"src":"/_next/static/media/credit-card-icon.6198619f.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};